var _path, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgGif = function SvgGif(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none"
  }, props), /*#__PURE__*/React.createElement("mask", {
    id: "gif_svg__a",
    width: 24,
    height: 24,
    x: 0,
    y: 0,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "alpha"
    }
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#D9D9D9",
    d: "M0 0h24v24H0z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#gif_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "current",
    d: "M12.25 14.847a.58.58 0 0 1-.596-.596v-4.5a.58.58 0 0 1 .596-.597.58.58 0 0 1 .597.597v4.5a.58.58 0 0 1-.596.596m-5.788 0q-.508 0-.85-.366a1.18 1.18 0 0 1-.342-.827v-3.307q0-.462.342-.827.342-.366.85-.366h2.904a.58.58 0 0 1 .596.596.58.58 0 0 1-.596.597H6.77a.3.3 0 0 0-.212.096.3.3 0 0 0-.096.211v2.693q0 .115.096.211a.3.3 0 0 0 .212.096h1.692a.3.3 0 0 0 .211-.096.3.3 0 0 0 .097-.211v-.673a.58.58 0 0 1 .595-.596q.258 0 .428.167.168.168.169.424v.985q0 .462-.342.827a1.12 1.12 0 0 1-.85.366zm8.673 0a.58.58 0 0 1-.596-.596v-4.5a.58.58 0 0 1 .596-.597h3a.58.58 0 0 1 .596.596.58.58 0 0 1-.596.597H15.73v1.23h1.404a.58.58 0 0 1 .596.596.58.58 0 0 1-.596.597H15.73v1.48a.58.58 0 0 1-.596.597"
  }))));
};
export default SvgGif;